import { get as lodashGet } from 'lodash'
import WarningTip from './components/WarningTip'
import ErrorTip from './components/ErrorTip'
import Vue from 'vue'

const NOT_ARRIVE_SERVICE = `请求没有到达服务器，请<a href="dingtalk://dingtalkclient/action/jumprobot?dingtalkid=%24%3ALWCP_v1%3A%24Tk6uimrUVj7XLV2ukl91%2FibYyDaFQNo6&content=%E6%82%A8%E5%A5%BD%7E "> 联系IT </a>或运维` // 无状态码 无traceid
const NOT_ARRIVE_WG = `请求没有到达网关，请<a href="dingtalk://dingtalkclient/action/jumprobot?dingtalkid=%24%3ALWCP_v1%3A%24Tk6uimrUVj7XLV2ukl91%2FibYyDaFQNo6&content=%E6%82%A8%E5%A5%BD%7E "> 联系IT </a>或运维` // 有状态码 无traceid

// https://github.dev/axios/axios/blob/649d739288c8e2c55829ac60e2345a0f3439c730/lib/core/AxiosError.js#L59
const axiosCodeToDesc = {
  ERR_BAD_OPTION_VALUE: '',
  ERR_BAD_OPTION: '',
  ECONNABORTED: '网络异常',
  ETIMEDOUT: '',
  ERR_NETWORK: '',
  ERR_FR_TOO_MANY_REDIRECTS: '',
  ERR_DEPRECATED: '',
  ERR_BAD_RESPONSE: '',
  ERR_BAD_REQUEST: '',
  ERR_CANCELED: '',
  ERR_NOT_SUPPORT: '',
  ERR_INVALID_URL: ''
}

export function genErrorMessage(message = '', config, response, code = '', actionType = 'Notification') {
  // console.log(config, response)
  try {
    const status = +lodashGet(response, 'status') || 0
    const url = lodashGet(config, 'url', '') || lodashGet(response, 'config.url', '') || ''
    const baseURL = lodashGet(config, 'baseURL', '') || lodashGet(response, 'config.baseURL', '') || ''
    const traceId = lodashGet(response, 'headers.traceid', '') || lodashGet(response, 'headers.traceId', '') || ''
    const path = url.replace(baseURL, '').split('?')[0]
    if (String(message) && String(message).match(/(com.mysql.jdbc)/)) message = '数据库异常，请联系值班的研发同事'
    if (String(message) && String(message).match(/(request timeout)/)) message = '请求超时，请稍后重试'
    if (!status && !traceId) message = NOT_ARRIVE_SERVICE
    if (status && !traceId) message = NOT_ARRIVE_WG
    if (status === 401) message = '登录失效，请尝试重新登录'
    return new Vue({
      render: h =>
        h(actionType === 'Message' ? WarningTip : ErrorTip, {
          props: {
            warningMessage: message,
            traceId,
            status,
            errorPath: path,
            errorCode: code
          }
        })
    }).$mount()
  } catch (e) {
    console.error(e)
    return null
  }
}
